import { useTranslation } from 'react-i18next';

export default function AboutSection() {
  const { t } = useTranslation();

  return (
    <section className="py-16 md:py-24 bg-accent-100/40">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <span className="inline-block px-4 py-1.5 text-xs font-semibold bg-white/70 text-accent-700 rounded-full mb-6">
          {t('about.tag')}
        </span>

        <h2 className="text-3xl md:text-5xl font-heading font-bold text-foreground-900 leading-tight mb-6 max-w-2xl">
          {t('about.title')}
        </h2>

        <p className="text-base md:text-lg text-foreground-600 max-w-2xl mb-12 leading-relaxed">
          {t('about.description')}
        </p>

        <div className="grid grid-cols-2 md:grid-cols-5 gap-4 md:gap-6 mb-16">
          {[t('about.benefit1'), t('about.benefit2'), t('about.benefit3'), t('about.benefit4'), t('about.benefit5')].map((benefit) => (
            <div key={benefit} className="flex items-start gap-2">
              <i className="ri-checkbox-circle-fill text-accent-600 text-lg flex-shrink-0 mt-0.5"></i>
              <span className="text-sm text-foreground-700">{benefit}</span>
            </div>
          ))}
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 md:gap-12">
          {[
            { value: t('about.stat1'), label: t('about.stat1Label') },
            { value: t('about.stat2'), label: t('about.stat2Label') },
            { value: t('about.stat3'), label: t('about.stat3Label') },
            { value: t('about.stat4'), label: t('about.stat4Label') },
          ].map((stat) => (
            <div key={stat.label} className="text-center">
              <p className="text-4xl md:text-5xl font-heading font-bold text-accent-700 mb-2">
                {stat.value}
              </p>
              <p className="text-sm text-foreground-500">{stat.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}